import { Fragment } from "react";
import Head from "next/head";
import ContentCard from "@/components/UI/content-card/content_card";
import style from "./style.module.css";

export default function Cookies() {
  return (
    <Fragment>
      <Head>
        <title>
          คุกกี้และเทคโนโลยีการจัดเก็บข้อมูลอื่นๆ บริษัท ทีคิวเอ็ม โบรกเกอร์
          จำกัด(มหาชน)
        </title>
      </Head>
      <section className={style.pdpa_section}>
        <div className={style.pdpa_container}>
          <ContentCard>
            <h1>คุกกี้และเทคโนโลยีการจัดเก็บข้อมูลอื่นๆ</h1>
            <h2>คุกกี้คืออะไร</h2>
            <p>
              คุกกี้คือข้อความส่วนเล็กๆ
              ที่ใช้เพื่อจัดเก็บข้อมูลบนเว็บเบราว์เซอร์
              คุกกี้ถูกใช้เพื่อจัดเก็บและรับตัวระบุ รวมทั้งข้อมูลอื่นๆ
              บนคอมพิวเตอร์ โทรศัพท์ และอุปกรณ์อื่นๆ
              นอกจากนี้เรายังใช้เทคโนโลยีอื่นๆ
              รวมถึงข้อมูลที่เราจัดเก็บไว้บนเว็บเบราว์เซอร์หรืออุปกรณ์ของคุณ
              ตัวระบุที่เชื่อมโยงกับอุปกรณ์ของคุณ และซอฟต์แวร์อื่นๆ
              เพื่อวัตถุประสงค์ที่คล้ายกัน ในนโยบายนี้
              เราเรียกเทคโนโลยีเหล่านี้ทั้งหมดว่า “คุกกี้”
            </p>
            <p>
              เราใช้คุกกี้ในกรณีที่คุณเข้าเยี่ยมชมหรือใช้บริการที่เว็บไซต์และแอพลิเคชั่นของเรา
              ซึ่งคุกกี้จะช่วยให้สามารถบริการผลิตภัณฑ์ในเครือแก่คุณ
              และช่วยให้เราเข้าใจข้อมูลที่เราได้รับเกี่ยวกับคุณได้
              ซึ่งรวมถึงข้อมูลเกี่ยวกับการใช้เว็บไซต์และแอปพลิเคชั่นอื่นๆ
              ของคุณไม่ว่าคุณจะลงทะเบียนหรือเข้าสู่ระบบอยู่หรือไม่ก็ตาม
            </p>
            <p>
              นโยบายนี้อธิบายวิธีที่เราใช้คุกกี้และตัวเลือกที่คุณมี
              เว้นแต่จะระบุไว้เป็นอย่างอื่นในนโยบายนี้
              นโยบายคุ้มครองข้อมูลส่วนบุคคล
              จะมีผลบังคับใช้กับการประมวลผลของข้อมูลที่เราเก็บผ่านคุกกี้
            </p>
            <h2>ทำไมเราต้องใช้คุกกี้</h2>
            <p>
              คุกกี้ช่วยให้เราจัดหา ปกป้อง และปรับปรุงผลิตภัณฑ์ในเครือบริษัทฯได้
              เช่น การปรับเนื้อหาให้เหมาะกับผู้ใช้ การปรับแต่งและการวัดผลโฆษณา
              และการมอบประสบการณ์ที่ปลอดภัยยิ่งขึ้น
              คุกกี้ที่เราใช้ประกอบไปด้วยคุกกี้ชั่วคราว
              ซึ่งจะถูกลบออกเมื่อคุณปิดเบราว์เซอร์
              และคุกกี้ระยะยาวซึ่งจะอยู่บนเบราว์เซอร์ของคุณจนกว่าจะหมดอายุหรือจนกว่าคุณจะลบออก
              ถึงแม้ว่าคุกกี้ที่เราใช้นั้นอาจเปลี่ยนไปบ้างเป็นครั้งคราวตามการปรับปรุงและอัปเดตผลิตภัณฑ์ในเครือบริษัทฯ
              ของเรา เราจะใช้คุกกี้เพื่อวัตถุประสงค์ต่อไปนี้
            </p>
            <h3>1. การยืนยันตัวตน</h3>
            <p>
              เราใช้คุกกี้เพื่อตรวจสอบยืนยันบัญชีของคุณและระบุเวลาที่คุณเข้าสู่ระบบเพื่อให้เราสามารถช่วยให้คุณเข้าถึงผลิตภัณฑ์ในเครือบริษัทฯได้ง่ายขึ้น
              และแสดงให้คุณเห็นถึงประสบการณ์และฟีเจอร์ที่เหมาะสม
            </p>
            <ul>
              <li>
                <h4>
                  - ความสมบูรณ์พร้อมของการรักษาความปลอดภัย เว็บไซต์ และผลิตภัณฑ์
                </h4>
                <p>
                  เราใช้คุกกี้เพื่อช่วยเรารักษาบัญชี ข้อมูลของคุณ
                  และผลิตภัณฑ์ในเครือบริษัทฯ ให้มีความปลอดภัยและมั่นคง
                  เรายังใช้คุกกี้เพื่อจัดการกับกิจกรรมที่ละเมิดนโยบายของเรา
                  หรือที่ลดความสามารถของเราในการจัดหาผลิตภัณฑ์ในเครือบริษัทฯอีกด้วย
                </p>
              </li>
              <li>
                <h4>- การโฆษณา คำแนะนำ ข้อมูลเชิงลึก และการวัดผล</h4>
                <p>
                  เราใช้คุกกี้เพื่อช่วยให้เราแสดงโฆษณาและแนะนำธุรกิจและองค์กรอื่นๆ
                  ให้แก่ผู้ที่อาจสนใจผลิตภัณฑ์ บริการ
                  หรือจุดประสงค์ที่พวกเขาโปรโมต
                  นอกจากนี้เรายังใช้คุกกี้เพื่อช่วยวัดประสิทธิภาพของแคมเปญโฆษณาสำหรับธุรกิจที่ใช้ผลิตภัณฑ์ในเครือบริษัทฯ
                  คุกกี้ช่วยให้เราสามารถนำเสนอและวัดผลโฆษณาในเบราว์เซอร์และอุปกรณ์ต่างๆ
                  ที่ใช้โดยบุคคลเดียวกัน
                  คุกกี้ยังช่วยให้เราสามารถจัดหาข้อมูลเชิงลึกเกี่ยวกับผู้ที่ใช้ผลิตภัณฑ์ในเครือ
                  บริษัทฯ รวมถึงผู้ที่โต้ตอบกับโฆษณา เว็บไซต์
                  และแอพของผู้ลงโฆษณาของเราและธุรกิจต่างๆ
                  ที่ใช้ผลิตภัณฑ์ในเครือบริษัทฯ นอกจากนี้
                  เรายังใช้คุกกี้อย่างเช่นคุกกี้ “oo” ซึ่งจะมีอายุการใช้งาน 5 ปี
                  เพื่อให้คุณสามารถเลือกที่จะไม่เห็นโฆษณาจากบริษัทฯ
                  โดยอิงจากกิจกรรมของคุณบนเว็บไซต์ของบุคคลที่สามได้
                  วิธีที่เราใช้ในการตัดสินใจว่าจะแสดงโฆษณาใดให้คุณเห็นบ้างทั้งในและนอกผลิตภัณฑ์ในเครือบริษัทฯ
                  และการควบคุมที่คุณสามารถใช้ได้
                </p>
              </li>
            </ul>
            <h3>2. คุณสมบัติและบริการของเว็บไซต์</h3>
            <p>
              เราใช้คุกกี้เพื่อให้ฟังก์ชั่นที่ช่วยให้เราจัดหาผลิตภัณฑ์ในเครือบริษัทฯ
              ทำงานได้ตามปกติ
              นอกจากนี้เรายังใช้คุกกี้ในการมอบเนื้อหาที่เกี่ยวข้องกับภาษาของคุณให้กับคุณอีกด้วย
            </p>
            <ul>
              <li>
                <h4>- ประสิทธิภาพ</h4>
                <p>
                  เราใช้คุกกี้เพื่อมอบประสบการณ์การใช้งานที่ดีที่สุดให้แก่คุณ
                </p>
              </li>
              <li>
                <h4>- ข้อมูลวิเคราะห์และการศึกษาวิจัย</h4>
                <p>
                  เราใช้คุกกี้เพื่อให้เข้าใจมากยิ่งขึ้นว่าผู้คนใช้ผลิตภัณฑ์ในเครือบริษัทฯ
                  อย่างไรเพื่อที่เราจะได้ปรับปรุงผลิตภัณฑ์ต่อไป
                </p>
              </li>
              <li>
                <h4>- Google Analytics</h4>
                <p>
                  นอกจากนี้เรายังตั้งค่าคุกกี้จากโดเมน tqm.co.th
                  ที่ทำงานร่วมกับบริการ Google Analytics
                  เพื่อช่วยให้เราทราบวิธีที่ธุรกิจต่างๆ
                  ใช้เว็บไซต์ผู้พัฒนาของบริษัทฯอีกด้วย คุกกี้เหล่านี้มีชื่อต่างๆ
                </p>
              </li>
              <li>
                <h4>- เว็บไซต์และแอปพลิเคชั่นของบุคคลที่สาม</h4>
                <p>
                  พาร์ทเนอร์ทางธุรกิจของเราอาจเลือกที่จะแชร์ข้อมูลกับบริษัทฯ
                  จากคุกกี้ที่ตั้งค่าไว้ในโดเมนเว็บไซต์ของตน
                  แม้ว่าคุณจะมีบัญชีบริษัทฯ หรือเข้าสู่ระบบอยู่หรือไม่ก็ตาม
                  โดยเฉพาะอาจมีการตั้งค่าคุกกี้
                  ไว้บนโดเมนของพาร์ทเนอร์ทางธุรกิจของบริษัทฯ
                  ที่เป็นเจ้าของเว็บไซต์ที่คุณเข้าชมอยู่บริษัทฯ
                  จะไม่สามารถเข้าถึงคุกกี้เหล่านี้ได้หากคุณอยู่บนเว็บไซต์อื่นนอกเหนือจากเว็บไซต์ที่ได้ตั้งค่าคุกกี้ไว้
                  รวมถึงเมื่อคุณอยู่บนโดเมนใดๆ ของเรา
                  ซึ่งจะแตกต่างจากคุกกี้ที่ตั้งค่าไว้บนโดเมนของบริษัทฯเอง
                  โดยคุกกี้ดังกล่าวจะทำหน้าที่เหมือนกันกับคุกกี้ที่ตั้งค่าไว้บนโดเมนของบริษัทฯเองซึ่งได้แก่
                  ปรับเนื้อหา (รวมถึงโฆษณา) ให้เหมาะสมกับบุคคล วัดผลโฆษณา
                  ดำเนินการวิเคราะห์ และมอบประสบการณ์ที่ปลอดภัยมากขึ้น
                  ตามที่ระบุไว้ในนโยบายคุกกี้ฉบับนี้
                </p>
              </li>
            </ul>
            <h3>3. เราจะใช้คุกกี้ที่ใด</h3>
            <p>
              เราอาจวางคุกกี้ไว้บนคอมพิวเตอร์หรืออุปกรณ์ของคุณเพื่อรับข้อมูลที่จัดเก็บไว้ในคุกกี้เมื่อคุณใช้งานหรือเข้าชม
              :
              <ul>
                <li>- ผลิตภัณฑ์ในเครือบริษัทฯ</li>
                <li>
                  - ผลิตภัณฑ์ที่ให้บริการโดยสมาชิกรายอื่นของบริษัทในเครือบริษัท
                </li>
                <li>
                  - เว็บไซต์และแอปพลิเคชั่นที่จัดหาให้โดยบริษัทอื่นๆ
                  ที่ใช้ผลิตภัณฑ์ในเครือ TQM
                  ซึ่งรวมถึงบริษัทที่ผสานรวมเทคโนโลยีของบริษัทฯ
                  เข้าไปในเว็บไซต์หรือแอปพลิเคชั่นของตน TQM
                  จะใช้คุกกี้เพื่อรับข้อมูลเมื่อคุณเข้าชมเว็บไซต์และแอพเหล่านั้น
                  ซึ่งรวมถึงข้อมูลเกี่ยวกับอุปกรณ์และข้อมูลเกี่ยวกับกิจกรรมของคุณโดยคุณไม่ต้องดำเนินการใดๆ
                  เพิ่มเติม
                  ซึ่งจะเกิดขึ้นแม้ว่าคุณจะมีบัญชีบริษัทฯหรือเข้าสู่ระบบอยู่หรือไม่ก็ตาม
                </li>
              </ul>
            </p>
            <h3>4. ท่านจะจัดการคุกกี้อย่างไร</h3>
            <p>
              เบราว์เซอร์ส่วนใหญ่จะมีการตั้งค่าให้ยอมรับคุกกี้โดยอัตโนมัติ
              แต่ท่านสามารถเลือกยอมรับหรือปฏิเสธคุกกี้จากบริการของบริษัทฯ
              ได้ตลอดเวลาโดยการตั้งค่าบนเบราว์เซอร์ที่ท่านใช้งาน
            </p>
            <p>
              ลิงก์ด้านล่างนี้จะนำท่านไปสู่บริการ “การช่วยเหลือ”
              ของเบราว์เซอร์ต่าง ๆ ซึ่งเป็นที่นิยมใช้งานได้มีการบริการไว้
              ท่านสามารถค้นหาข้อมูลการจัดการคุกกี้ของเบราว์เซอร์ที่ท่านใช้งานได้
            </p>
            <ul>
              <li>
                - Internet Explorer <br />
                <a rel="nofollow" href="https://support.microsoft.com/th-th/help/17479/windows-internet-explorer-11-change-security-privacy-settings">
                  https://support.microsoft.com/th-th/help/17479/windows-internet-explorer-11-change-security-privacy-settings
                </a>
              </li>
              <li>- Microsoft Edge <br />
                <a rel="nofollow" href="https://support.microsoft.com/en-us/help/4534105">
                https://support.microsoft.com/en-us/help/4534105
                </a></li>
              <li>- Google Chrome <br />
                <a rel="nofollow" href="https://support.google.com/chrome/answer/95647?hl=en">
                https://support.google.com/chrome/answer/95647?hl=en
                </a></li>
              <li>- Firefox <br />
                <a rel="nofollow" href="http://support.mozilla.org/en-US/kb/Cookies">
                http://support.mozilla.org/en-US/kb/Cookies
                </a></li>
              <li>- Safari <br />
                <a rel="nofollow" href="https://support.apple.com/en-gb/guide/safari/sfri11471/mac">
                https://support.apple.com/en-gb/guide/safari/sfri11471/mac
                </a></li>
              <li>- Safari iOS <br />
                <a rel="nofollow" href="https://support.apple.com/en-us/HT201265">
                https://support.apple.com/en-us/HT201265
                </a></li>
              <li>- Android <br />
                <a rel="nofollow" href="http://support.google.com/chrome/answer/2392971?hl=en-GB">
                http://support.google.com/chrome/answer/2392971?hl=en-GB
                </a></li>
            </ul>
            <p>ทั้งนี้ โปรดทราบว่า หากท่านเลือกที่จะปิดการใช้งานคุกกี้บนเบราว์เซอร์หรืออุปกรณ์ของท่าน ท่านอาจพบว่าบางส่วนของเว็บไซต์ของ TQM ไม่สามารถทำงานหรือให้บริการได้เป็นปกติ</p>
            <p>สำหรับข้อมูลอื่น ๆ เพิ่มเติมในเรื่องนี้ ท่านสามารถเข้าไปอ่านได้ที่ <a href="https://www.aboutcookies.org/how-to-delete-cookies">https://www.aboutcookies.org/how-to-delete-cookies</a></p>
          </ContentCard>
        </div>
      </section>
    </Fragment>
  );
}
